export default __webpack_public_path__ + "static/media/Accent_Fix.16186c13.png";